import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { GetDeliveryPromiseOfferRankingRequest, GetDeliveryPromiseOfferRankingResponse } from 'services';
import { api } from 'services/api';
import { DeliveryPromiseOfferComparisonWithState, MerchantBusinessHours } from 'state/types';
import DeliveryPromiseUtils from 'state/utils/DeliveryPromiseUtils';
import createAsyncSaga from '../createAsyncSaga';
import { addDeliveryPromiseWithState, FEATURE_NAME } from './slice';

export const getDeliveryPromiseOfferRankingByStateSaga = createAsyncSaga<void, GetDeliveryPromiseOfferRankingRequest>(
    `${FEATURE_NAME}/saga/getDeliveryPromiseByState`,
    function* (request: GetDeliveryPromiseOfferRankingRequest) {
        const response: AxiosResponse<GetDeliveryPromiseOfferRankingResponse> = yield call(api.getDeliveryPromiseByState, request);
        const state: DeliveryPromiseOfferComparisonWithState = response.data
        const updatedState: DeliveryPromiseOfferComparisonWithState = DeliveryPromiseUtils.refreshProviderAvailableStatus(state)
        yield put(addDeliveryPromiseWithState(updatedState));
    }
);

function* watchGetDeliveryPromiseByState() {
    yield takeEvery(getDeliveryPromiseOfferRankingByStateSaga.type, getDeliveryPromiseOfferRankingByStateSaga.saga);
}

export default function* sagas() {
    yield all([
        fork(watchGetDeliveryPromiseByState),
    ]);
}